import React from "react";
import { FaPlus } from "react-icons/fa";

function CryptoWalletHero() {
  return (
    <>
      {/* <div
        className="banner-style-six-area bg-theme text-light bg-cover"
        style={{
          background:
            "url(https://validthemes.net/site-template/robok/assets/img/shape/banner-18.jpg)",
        }}
      >
        <div className="container">
          <div className="banner-six-top-info">
            <div className="row">
              <div className="col-xl-6 col-lg-6">
                <h2 className="split-lines">
                  Cryptocurrency Wallet Development
                </h2>
              </div>
              <div className="col-xl-5 offset-xl-1 col-lg-6">
                <p>
                  Building advanced and secure cryptocurrency wallets for
                  effortless digital asset management while offering seamless
                  integration, multi-currency support, and robust security
                  features.
                </p>
              </div>
            </div>
          </div>
          <div className="banner-bottom-info">
            <div className="row">
              <div className="col-lg-4">
                <div
                  className="community-card-two bg-theme text-light bg-cover shadow theme"
                  style={{
                    backgroundImage:
                      "url(https://validthemes.net/site-template/robok/assets/img/shape/banner-2.jpg)",
                  }}
                >
                  <h4>AI Community</h4>
                  <p>
                    Join the design community and unleash your creative studio
                  </p>
                  <div className="multi-users">
                    <FaPlus className="text-2xl text-white" />
                    <h5>10M User</h5>
                  </div>
                </div>
              </div>
              <div className="col-lg-8">
                <div className="thumb">
                  <img
                    src="https://validthemes.net/site-template/robok/assets/img/banner/4.jpg"
                    alt="Image Not Found"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> */}
      <div
        className="banner-style-two-area bg-theme shadow theme text-light bg-cover"
        style={{
          background:
            "url(assets/img/bg/white_label_crypto_exchange_image.jpg)",
        }}
      >
        <div className="container">
          <div className="row align-center">
            <div className="col-xl-9 col-lg-8">
              <div className="banner-two-content">
                <h2 className="split-text-right split-text-in-right">
                  Cryptocurrency Wallet Development
                </h2>
                <div className="info">
                  <p className="fade-up-anim">
                    Building advanced and secure cryptocurrency wallets for
                    effortless digital asset management while offering seamless
                    integration, multi-currency support, and robust security
                    features.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default CryptoWalletHero;
